import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Mail } from "lucide-react";

export default function Sequences() {
  const [sequences, setSequences] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/sequences").then((r) => setSequences(r.data.sequences));
  }, []);

  return (
    <div className="p-8 lg:p-10" data-testid="dashboard-sequences">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#8c9b86]">Automation</div>
        <h1 className="font-serif-display text-4xl mt-2">Email sequences</h1>
        <p className="text-[#5c5c5c] mt-2 text-sm max-w-lg">Every captured lead is enrolled in your active sequence. Emails are queued and sent automatically over four days.</p>
      </div>

      <div className="mt-8 space-y-4">
        {sequences.length === 0 && <div className="text-sm text-[#5c5c5c]">No sequences yet.</div>}
        {sequences.map((s) => (
          <div key={s.id} className="rounded-lg border border-[#e5e2da] bg-white" data-testid={`sequence-${s.id}`}>
            <div className="p-6 flex items-baseline justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <div className="font-serif-display text-2xl">{s.name}</div>
                  {s.is_active && <Badge style={{ background: "#163325", color: "#f9f8f6", fontWeight: 500 }}>Active</Badge>}
                </div>
                <p className="text-sm text-[#5c5c5c] mt-1">{s.description}</p>
              </div>
              <div className="text-right">
                <div className="font-serif-display text-3xl text-[#163325]">{s.send_count}</div>
                <div className="text-xs uppercase tracking-widest text-[#5c5c5c]">emails scheduled</div>
              </div>
            </div>
            <div className="border-t border-[#e5e2da] divide-y divide-[#e5e2da]">
              {s.emails.map((e, i) => (
                <div key={i} className="p-6 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "#efece5", color: "#163325" }}>
                    <Mail className="w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-baseline justify-between gap-4">
                      <div className="text-sm font-medium">{e.subject}</div>
                      <div className="text-xs text-[#8c9b86] uppercase tracking-widest whitespace-nowrap">{e.delay_hours === 0 ? "Instantly" : `+${e.delay_hours}h`}</div>
                    </div>
                    <button
                      onClick={() => setOpen(open === `${s.id}-${i}` ? null : `${s.id}-${i}`)}
                      className="text-xs text-[#163325] underline underline-offset-4 mt-1"
                      data-testid={`sequence-preview-${s.id}-${i}`}
                    >
                      {open === `${s.id}-${i}` ? "Hide preview" : "Preview email"}
                    </button>
                    {open === `${s.id}-${i}` && (
                      <pre className="mt-3 text-xs whitespace-pre-wrap bg-[#f9f8f6] rounded p-3 text-[#3c3c3c] border border-[#e5e2da] font-sans">{e.body}</pre>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
